module.exports = __webpack_public_path__ + "img/news9-1.49dba89b.png";